import { AGENT_TYPES as D } from "../../models/agentic/dist/src/AgentType.js";
const I = 2e3, r = (e) => e.toISOString().split(".")[0] + "Z", g = (e) => {
  const t = /* @__PURE__ */ new Date(), o = new Date(t.getTime() - (e + 1) * 24 * 60 * 60 * 1e3);
  return {
    id: `agent-${e + 1}`,
    name: `Conversational Agent ${e + 1}`,
    description: e % 2 === 0 ? `Description for agent ${e + 1}` : "",
    agentType: D.SEARCH_AGENT,
    passageRetrievalModelId: `passage-model-${e % 3 + 1}`,
    answerModelId: `answer-model-${e % 3 + 1}`,
    followUpModelId: `followup-model-${e % 3 + 1}`,
    numberOfItemsToConsider: e % 2 === 0 ? 50 + e * 5 : void 0,
    followUpEnabled: !0,
    createdDate: r(o),
    modifiedDate: r(t)
  };
}, A = (e, t) => {
  const o = t?.page ?? 0, n = t?.perPage ?? 25, l = Array.from({ length: e }, (c, s) => g(s));
  t?.sortingType && l.sort((c, s) => {
    const f = c[t.sortingType], w = s[t.sortingType], i = String(f ?? "").localeCompare(String(w ?? ""));
    return t.sortingOrder === "DSC" ? -i : i;
  });
  const d = o * n, m = l.slice(d, d + n), p = Math.ceil(e / n);
  return {
    pagination: {
      page: o,
      perPage: n,
      totalItems: e,
      totalPages: p
    },
    items: m
  };
}, S = (e) => {
  const t = r(/* @__PURE__ */ new Date());
  return {
    id: `agent-${Date.now()}`,
    name: e.name,
    description: e.description ?? "",
    agentType: e.agentType,
    passageRetrievalModelId: e.passageRetrievalModelId,
    answerModelId: e.answerModelId,
    followUpModelId: e.followUpModelId,
    numberOfItemsToConsider: e.numberOfItemsToConsider,
    followUpEnabled: e.followUpEnabled,
    createdDate: t,
    modifiedDate: t
  };
};
let a = [];
const M = (e = 5) => {
  a = Array.from({ length: e }, (t, o) => g(o));
}, y = (e, t) => {
  const o = a.findIndex((n) => n.id === e);
  return o === -1 ? null : (a[o] = {
    ...a[o],
    ...t,
    modifiedDate: r(/* @__PURE__ */ new Date())
  }, a[o]);
}, u = (e, t = I) => new Promise((o) => {
  setTimeout(() => o(e), t);
});
M(5);
export {
  S as createMockAgentFromRequest,
  g as createMockAgentItem,
  A as createMockAgentListResponse,
  M as initializeMockAgentStore,
  y as updateMockAgent,
  u as withDelay
};
//# sourceMappingURL=AgentConfigurationResource.mocks.js.map
